import { render, staticRenderFns } from "./UpdateFile.vue?vue&type=template&id=b935e5de&scoped=true&"
import script from "./UpdateFile.vue?vue&type=script&lang=js&"
export * from "./UpdateFile.vue?vue&type=script&lang=js&"
import style0 from "./UpdateFile.vue?vue&type=style&index=0&id=b935e5de&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b935e5de",
  null
  
)

export default component.exports